/**
 * Фильтр референсов «генерация: все | была | не было» — по счётчику `generations`
 * (генерации с этим референсом в любом статусе, `library.items`). Модуль без импортов:
 * его напрямую грузит `node --test`.
 */
export type UsedFilter = "all" | "yes" | "no";

export function byUsed<T extends { generations: number }>(items: T[], filter: UsedFilter): T[] {
  if (filter === "all") return items;
  return items.filter((i) => (i.generations > 0) === (filter === "yes"));
}

export function usedCounts(items: readonly { generations: number }[]): Record<UsedFilter, number> {
  const yes = items.filter((i) => i.generations > 0).length;
  return { all: items.length, yes, no: items.length - yes };
}
